import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { useSelector } from "react-redux";
import { useActions } from "../redux/useActions";
import { getRooms as getRoomsAction } from "../actions/roomActions";
import { Typography, Button, Grid, Divider } from "@material-ui/core";
import { Link } from "react-router-dom";
import Rooms from "./Rooms";
import Cubes from "../resources/diagmonds.png";
import JButton from "./Input/JButton";

const useStyles = makeStyles(theme => ({
  root: {
    //padding: theme.spacing(2),
    backgroundImage: "url('" + Cubes + "')",
    height: "calc(100vh - " + theme.spacing(8) + "px)"
  },

  top: {
    //maxWidth: "1920px"
  },

  topBackground: {
    //backgroundImage:
    //  "url('http://images6.fanpop.com/image/photos/36300000/Random-image-random-36338374-1280-1024.jpg')",
    //backgroundImage: "linear-gradient(120deg, #e0c3fc 0%, #8ec5fc 100%)"
    //backgroundSize: "auto",
    //backgroundPosition: "center",
    //backgroundRepeat: "no-repeat"
    //opacity: 0.3
  },

  topContent: {
    //zIndex: theme.zIndex.modal + 1,
  },

  debug: {
    display: "absolute",
    bottom: 0,
    left: 0
  },

  header: {
    marginTop: theme.spacing(5)
  },

  buttons: {
    marginTop: theme.spacing(2)
  },

  divider: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4)
  },

  footer: {
    marginTop: theme.spacing(4)
  },
  jbutton: {
    background:
      "linear-gradient(45deg, rgb(33, 150, 243) 30%, rgb(33, 203, 243) 90%);",
    borderRadius: 3,
    border: 0,
    fontSize: 16,
    boxShadow: "rgba(33, 203, 243, 0.3) 0px 3px 5px 2px",
    color: "white",
    height: 48,
    padding: "0 30px"
  }
}));

export default function Home() {
  const classes = useStyles();

  const authState = useSelector(state => state.auth);

  const getType = type => {
    return parseInt(type, 10) === 0 ? "Guest" : "User";
  };

  return (
    <Grid container className={classes.root} justify="center">
      <Grid item className={classes.top}>
        <div className={classes.topBackground} />
        <div className={classes.header}>
          <Typography align="center" variant="h2" gutterBottom>
            Welcome to JChat
          </Typography>
          <Typography align="center" variant="subtitle1" gutterBottom>
            Connect and chat with friends
          </Typography>
          <Grid
            container
            justify="center"
            className={classes.buttons}
            spacing={1}
          >
            <Grid item>
              <Button size="large" variant="contained" style={{ height: 48 }}>
                Sign up
              </Button>
            </Grid>
            <Grid item>
              <Button className={classes.jbutton} component={Link} to="/rooms">
                Live Directory
              </Button>
            </Grid>
          </Grid>
          <Divider className={classes.divider} />
          <Typography align="center" className={classes.footer}>
            JChat ©
          </Typography>
        </div>
      </Grid>
    </Grid>
  );
}
